import { MEDIA_FILE_TYPE } from "../constants";

export function documentPhotoKey({ fileType, givenDocumentSideType }) {
  let photoKey = fileType;
  if (givenDocumentSideType) photoKey += givenDocumentSideType;
  return photoKey;
}

export function isNFCScanned(media) {
  return media?.find(({ fileType }) => fileType === MEDIA_FILE_TYPE.NFC_FACE);
}

export function getMostRecentDocument(media) {
  if (!media?.length) {
    return null;
  }

  return media.reduce((mostRecent, current) => {
    return mostRecent.created < current.created ? current : mostRecent;
  });
}
